module.exports = "<svg \n xmlns=\"http://www.w3.org/2000/svg\"\n xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n width=\"22\" height=\"22\" viewbox=\"0 0 22 22\">\n<path fill-rule=\"evenodd\"  fill=\"#000\" transform=\"translate(6 6)\"\n d=\"M10.000,6.000 L6.000,6.000 L6.000,10.000 L4.000,10.000 L4.000,6.000 L0.000,6.000 L0.000,4.000 L4.000,4.000 L4.000,-0.000 L6.000,-0.000 L6.000,4.000 L10.000,4.000 L10.000,6.000 Z\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ../iron/common/assets/icons/plus-medium.svg
// module id = 652
// module chunks = 0 1 3